import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { X } from 'lucide-react'

/** Centered modal — used for create/edit forms and confirmations. */
export function Modal({
  open, onClose, title, children, footer, width = 560,
}: { open: boolean; onClose: () => void; title?: ReactNode; children: ReactNode; footer?: ReactNode; width?: number }) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null
  return (
    <div className="modal-scrim" onMouseDown={onClose}>
      <div className="modal" style={{ maxWidth: width }} onMouseDown={(e) => e.stopPropagation()}>
        {title && (
          <header className="modal-head">
            <h2 className="modal-title mixed">{title}</h2>
            <button className="modal-close" onClick={onClose} aria-label="Close"><X size={18} /></button>
          </header>
        )}
        <div className="modal-body">{children}</div>
        {footer && <footer className="modal-foot">{footer}</footer>}
      </div>
    </div>
  )
}

/** Right-side drawer — used for record peeks and longer forms. */
export function Drawer({
  open, onClose, title, children, footer, width = 460,
}: { open: boolean; onClose: () => void; title?: ReactNode; children: ReactNode; footer?: ReactNode; width?: number }) {
  if (!open) return null
  return (
    <div className="drawer-scrim" onMouseDown={onClose}>
      <div className="drawer" style={{ width }} onMouseDown={(e) => e.stopPropagation()}>
        {title && (
          <header className="modal-head">
            <h2 className="modal-title mixed">{title}</h2>
            <button className="modal-close" onClick={onClose} aria-label="Close"><X size={18} /></button>
          </header>
        )}
        <div className="drawer-body">{children}</div>
        {footer && <footer className="modal-foot">{footer}</footer>}
      </div>
    </div>
  )
}
